export const API_VERSION = "v1" as const;
export const API_PREFIX = `/api/${API_VERSION}` as const;

export const SESSION_COOKIE_NAME = "jaiho_session" as const;

/** Application-level error codes returned in the JSON error envelope. */
export const ERROR_CODES = [
  "UNAUTHENTICATED",
  "INVALID_INIT_DATA",
  "SESSION_EXPIRED",
  "VALIDATION_ERROR",
  "NOT_FOUND",
  "RATE_LIMITED",
  "ALREADY_CLAIMED",
  "INSUFFICIENT_BALANCE",
  "INTERNAL_ERROR",
  "FORBIDDEN",
] as const;

export type ErrorCode = (typeof ERROR_CODES)[number];
